import React from "react";

import { XboxSpinner } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "../GdkMiddlewareRequestPage.module.css";

export const SubmittingStep = () => (
  <div className={styles.spinnerWrapper}>
    <XboxSpinner />
  </div>
);
